"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;
var validate = function validate(values) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var error;
  var completeCondition = settings.completeCondition,
    minimumNumber = settings.minimumNumber;
  var totalChildren = children.length;
  var totalFinished = children.filter(function (item) {
    return item.progress && item.progress.finishedFirst;
  }).length;
  if (completeCondition === 'all' && totalFinished < totalChildren) {
    return 'You have to complete all menu items before proceeding';
  }
  if (completeCondition === 'minimum' && totalFinished < minimumNumber) {
    return "You have to complete at least ".concat(minimumNumber, " menu items before proceeding");
  }
  return error;
};
exports.validate = validate;